import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function Cone({
  className,
  fillPrimary = colors.blue40,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[16px] w-[16px]', className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4096 15C1.95272 15 1.59375 14.6301 1.59375 14.1733C1.59375 13.7164 1.95272 13.3574 2.4096 13.3574H3.67067L4.56187 9H11.443L12.3513 13.3574H13.5798C14.0366 13.3574 14.4065 13.7164 14.4065 14.1733C14.4065 14.6301 14.0366 15 13.5798 15H2.4096ZM11.2345 8L10.8176 6H5.17544L4.76639 8H11.2345ZM10.6092 5H5.37996L5.9333 2.29448C6.11823 1.41336 6.61861 1 7.45622 1H8.54402C9.37075 1 9.87114 1.41336 10.0452 2.29448L10.6092 5Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
